/**
 * Retorna o caminho da logo do programa de fidelidade
 * Se não houver logo específica, retorna null para usar o ícone padrão
 */
export const getProgramLogo = (programName: string): string | null => {
  const name = programName.toLowerCase().trim();

  // Mapeamento completo dos programas disponíveis em public/programs
  const logoMap: Record<string, string> = {
    // Programas de milhas aéreas
    smiles: '/programs/Smiles.svg',
    latam: '/programs/LatamPass.svg',
    latampass: '/programs/LatamPass.svg',
    'latam pass': '/programs/LatamPass.svg',
    tudoazul: '/programs/TudoAzul.svg',
    'tudo azul': '/programs/TudoAzul.svg',
    azul: '/programs/TudoAzul.svg',
    aadvantage: '/programs/AAdvantage.svg',
    delta: '/programs/Delta.svg',
    'connect miles': '/programs/Connect Miles.svg',
    connectmiles: '/programs/Connect Miles.svg',
    qatar: '/programs/Qatar.svg',
    'tap miles': '/programs/Tap Miles & Go.svg',
    'virgin atlantic': '/programs/Virgin Atlantic.svg',
    ibéria: '/programs/Ibéria.svg',
    iberia: '/programs/Ibéria.svg',

    // Programas de pontos bancários/cartões
    livelo: '/programs/Livelo.svg',
    esfera: '/programs/Esfera.svg',
    átomos: '/programs/Átomos.svg',
    atomos: '/programs/Átomos.svg',
    'inter loop': '/programs/Inter Loop.svg',
    interloop: '/programs/Inter Loop.svg',
    iupp: '/programs/Iupp.svg',
    'nubank ultravioleta': '/programs/Nubank Ultravioleta.svg',
    ultravioleta: '/programs/Nubank Ultravioleta.svg',
    'itaú business': '/programs/Itaú Business Rewards.svg',
    'business rewards': '/programs/Itaú Business Rewards.svg',
    portoplus: '/programs/PortoPlus.svg',
    'porto plus': '/programs/PortoPlus.svg',
    único: '/programs/Único.svg',
    unico: '/programs/Único.svg',
    xp: '/programs/XP.svg',
    btg: '/programs/BTG.svg',
    safra: '/programs/Safra.svg',
    caixa: '/programs/Caixa.svg',
    sicoob: '/programs/Sicoob.svg',
    sicredi: '/programs/Sicredi.svg',

    // Outros programas
    'all accor': '/programs/All Accor.svg',
    accor: '/programs/All Accor.svg',
    curtaí: '/programs/Curtaí.svg',
    curtai: '/programs/Curtaí.svg',
    'dux experience': '/programs/DUX Experience.svg',
    dux: '/programs/DUX Experience.svg',
  };

  // Procurar por correspondência parcial (case-insensitive)
  // Ordenar chaves por tamanho decrescente para priorizar matches mais específicos
  const sortedEntries = Object.entries(logoMap).sort((a, b) => b[0].length - a[0].length);

  for (const [key, logo] of sortedEntries) {
    if (name.includes(key)) {
      return logo;
    }
  }

  // Retorna null para usar ícone padrão se não encontrar logo
  return null;
};
